/** PM Layout — responsive layout, draggable separator, placeholder panel. */

const PM_HIDE_PLACEHOLDER_KEY = 'pm_hide_placeholder';

window.isPlaceholderHidden = function() {
  try {
    return localStorage.getItem(PM_HIDE_PLACEHOLDER_KEY) === '1';
  } catch { return false; }
};

window.dismissPlaceholderPanel = function() {
  try { localStorage.setItem(PM_HIDE_PLACEHOLDER_KEY, '1'); } catch {}
  window.applyPlaceholderPreference();
};

window.restorePlaceholderPanel = function() {
  try { localStorage.removeItem(PM_HIDE_PLACEHOLDER_KEY); } catch {}
  window.applyPlaceholderPreference();
};

/**
 * Apply the placeholder panel preference to the layout.
 * Must be called AFTER threads_main_resize() so the normal layout is
 * established first and sibling widths can be measured accurately.
 * Skips when a thread is open (normal 2-pane view applies instead).
 */
window.applyPlaceholderPreference = function() {
  var isThreadOpen = $("#threads_main").hasClass("threads--open");
  if (isThreadOpen) {
    document.documentElement.classList.remove('pm-placeholder-dismissed');
    return;
  }

  var hidden = window.isPlaceholderHidden();
  var $btn = $("#pm-show-placeholder-btn");
  var $tm = $("#threads_main");
  var $lc = $("#threads_left_container");

  if (hidden) {
    $btn.removeClass("hidden").addClass("flex");
    // On first load the early-paint CSS (html.pm-placeholder-dismissed) already
    // hides the right pane — just add the permanent class without re-measuring.
    var hadEarlyClass = document.documentElement.classList.contains('pm-placeholder-dismissed');
    if (hadEarlyClass) {
      $tm.addClass("pm-placeholder-hidden");
      // 100% width from the CSS rule is sufficient; no pixel calc needed
    } else {
      // Temporarily restore normal layout to measure sibling widths
      var wasHidden = $tm.hasClass("pm-placeholder-hidden");
      if (wasHidden) {
        $tm.removeClass("pm-placeholder-hidden");
        $lc[0].style.removeProperty("width");
        $lc[0].style.removeProperty("flex-basis");
        void $tm[0].offsetWidth; // force reflow
      }
      var rcWidth = $("#threads-right__container").outerWidth() || 0;
      var sepWidth = $("#separator").outerWidth() || 0;
      var lcWidth = $lc.outerWidth() || 0;
      var targetWidth = lcWidth + rcWidth + sepWidth;
      $tm.addClass("pm-placeholder-hidden");
      if (targetWidth > 0) {
        $lc[0].style.setProperty("flex-basis", targetWidth + "px", "important");
        $lc[0].style.setProperty("width", targetWidth + "px", "important");
      }
    }
  } else {
    $btn.addClass("hidden").removeClass("flex");
    $tm.removeClass("pm-placeholder-hidden");
    $lc[0].style.removeProperty("width");
    // Restore saved drag-resize flex-basis
    var savedPaneWidth = null;
    try { savedPaneWidth = localStorage.getItem('messages-left-pane-width'); } catch (e) {}
    if (savedPaneWidth) {
      $lc[0].style.flexBasis = parseInt(savedPaneWidth, 10) + 'px';
    } else {
      $lc[0].style.removeProperty("flex-basis");
    }
  }

  // Hand off from early-paint class to the proper pm-placeholder-hidden mechanism
  document.documentElement.classList.remove('pm-placeholder-dismissed');
};

window.initDraggableSeparator = function() {
  const separator = document.getElementById('separator');
  const leftPane = document.getElementById('threads_left_container');
  const rightPane = document.getElementById('threads-right__container');

  if (!separator || !leftPane || !rightPane) {
    return; // Elements not found, skip initialization
  }

  let isResizing = false;
  let startX = 0;
  let startLeftWidth = 0;

  const MIN_LEFT_WIDTH = 280;
  const MAX_LEFT_WIDTH = 800;
  const MIN_RIGHT_WIDTH = 450;

  // Save width to localStorage
  function saveLeftPaneWidth(width) {
    try {
      localStorage.setItem('messages-left-pane-width', width);
    } catch (e) {
      // Ignore localStorage errors
    }
  }

  // Load width from localStorage (returns null if not set)
  function loadLeftPaneWidth() {
    try {
      const savedWidth = localStorage.getItem('messages-left-pane-width');
      return savedWidth ? parseInt(savedWidth, 10) : null;
    } catch (e) {
      return null;
    }
  }

  // Apply the saved width on load (only if user has manually resized before)
  // Use flex-basis instead of width so the panel can still shrink responsively
  const savedWidth = loadLeftPaneWidth();
  if (savedWidth !== null) {
    const constrainedWidth = Math.max(MIN_LEFT_WIDTH, Math.min(MAX_LEFT_WIDTH, savedWidth));
    leftPane.style.flexBasis = constrainedWidth + 'px';
  }

  function startResize(e) {
    // Remove early-paint style tag so it doesn't fight with drag resize
    var earlyStyle = document.getElementById('pm-saved-pane-width');
    if (earlyStyle) earlyStyle.remove();

    isResizing = true;
    startX = e.clientX || e.touches[0].clientX;
    startLeftWidth = leftPane.offsetWidth;

    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';

    // Add overlay to prevent iframe/content interference
    const overlay = document.createElement('div');
    overlay.id = 'resize-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;cursor:col-resize;z-index:9999;';
    document.body.appendChild(overlay);

    e.preventDefault();
  }

  function doResize(e) {
    if (!isResizing) return;

    const currentX = e.clientX || e.touches[0].clientX;
    const deltaX = currentX - startX;
    const newLeftWidth = startLeftWidth + deltaX;

    // Calculate available space
    const container = leftPane.parentElement;
    const containerWidth = container.offsetWidth;
    const separatorWidth = separator.offsetWidth;
    const availableWidth = containerWidth - separatorWidth;
    const maxAllowedLeftWidth = Math.min(MAX_LEFT_WIDTH, availableWidth - MIN_RIGHT_WIDTH);

    // Constrain the width
    const constrainedWidth = Math.max(MIN_LEFT_WIDTH, Math.min(maxAllowedLeftWidth, newLeftWidth));

    if (constrainedWidth >= MIN_LEFT_WIDTH && constrainedWidth <= maxAllowedLeftWidth) {
      leftPane.style.flexBasis = constrainedWidth + 'px';
    }

    e.preventDefault();
  }

  function stopResize() {
    if (!isResizing) return;

    isResizing = false;
    document.body.style.cursor = '';
    document.body.style.userSelect = '';

    // Remove overlay
    const overlay = document.getElementById('resize-overlay');
    if (overlay) {
      overlay.remove();
    }

    // Save the final width
    saveLeftPaneWidth(leftPane.offsetWidth);

    // Trigger resize event to update other layout elements
    setTimeout(function() {
      if (typeof window.threads_main_resize === 'function') {
        window.threads_main_resize();
      }
    }, 10);
  }

  // Mouse events
  separator.addEventListener('mousedown', startResize);
  document.addEventListener('mousemove', doResize);
  document.addEventListener('mouseup', stopResize);

  // Touch events for mobile
  separator.addEventListener('touchstart', startResize, { passive: false });
  document.addEventListener('touchmove', doResize, { passive: false });
  document.addEventListener('touchend', stopResize);

  // Prevent context menu on separator
  separator.addEventListener('contextmenu', function(e) {
    e.preventDefault();
  });
};

window.threads_main_resize = function() {
  const viewportHeight = window.visualViewport ? window.visualViewport.height : $(window).height();
  const messagesContainer = $(".privateMessages");

  if (messagesContainer.length) {
    // Use viewport-relative geometry to avoid scroll offset shrinking fixed containers.
    const containerRect = messagesContainer.get(0).getBoundingClientRect();
    const bottomNav = document.querySelector('[data-component="mobile-bottom-nav"]');
    const bottomNavHeight = bottomNav ? bottomNav.getBoundingClientRect().height : 0;
    const maxHeight = Math.max(0, viewportHeight - bottomNavHeight);

    // Calculate how much height should be available.
    // Use containerRect.top if > 0 (accounts for leaderboard/header above).
    // When containerRect.top is 0 (e.g. page just loaded, leaderboard not yet rendered),
    // measure the leaderboard directly to avoid giving .privateMessages full viewport height.
    var topOffset = Math.max(containerRect.top, 0);
    if (topOffset === 0) {
      var adZone = document.querySelector('[data-component="MainContentRow"] [data-ad-zone="atf_lb"]');
      var leaderboardEl = adZone ? adZone.closest('[data-component="MainContentRow"] > div') : null;
      if (leaderboardEl) {
        var lbStyle = window.getComputedStyle(leaderboardEl);
        if (lbStyle.display !== 'none') {
          topOffset = leaderboardEl.offsetHeight || 0;
        }
      }
    }
    const availableHeight = Math.max(0, maxHeight - topOffset);

    // DEBUG: log layout measurements (temporary)
    console.log('[PM Layout]', {
      viewportHeight: viewportHeight,
      topOffset: topOffset,
      availableHeight: availableHeight,
      containerTop: containerRect.top,
      windowWidth: $(window).width()
    });

    // Set the max height for message images
    const max_photo_width = ($("#threads_right").width()) - 96;

    // Responsive breakpoints
    const windowWidth = $(window).width();
    const mobileBreakpoint = 900; // Single-pane mode
    const adHideBreakpoint = 1100; // Hide ads when too narrow for 3 panes
    const isMobile = windowWidth < mobileBreakpoint;
    const hideAds = windowWidth < adHideBreakpoint;

    // Check if a thread is currently open
    const isThreadOpen = $("#threads_main").hasClass("threads--open");

    // Check if threads list is empty (showing "No matches" or similar empty state)
    const hasNoThreads = $("#threads_left .pm_thread").length === 0;

    // Constrain #page on ultra-legacy to prevent ad scripts from expanding it
    const isUltraLegacy = !!document.querySelector('.ultra-legacy-page');

    // Apply responsive layout styles
    let style = $("<style type='text/css'>" +
      (isUltraLegacy ? " .ultra-legacy-page { height: 100vh !important; overflow: hidden !important; } " : "") +
      " .privateMessages { height: " + availableHeight + "px !important; }" +
      " .msg_txt IMG, .msg_body IMG { max-width: " + max_photo_width + "px; }" +

      // Mobile styles - single pane view
      (isMobile ?
        " @media (max-width: " + mobileBreakpoint + "px) {" +
        // Hide ads on mobile
        "   .privateMessages + div { display: none !important; }" +

        // Hide separator on mobile (single pane view)
        "   #separator { display: none !important; }" +

        // Single pane layout
        "   #threads_main > div:first-child {" +
        "     display: " + (isThreadOpen ? "none" : "flex") + " !important;" +
        "     width: 100% !important;" +
        "     min-width: unset !important;" +
        "     max-width: unset !important;" +
        "   }" +
        "   #threads-right__container {" +
        "     display: " + (isThreadOpen ? "flex" : "none") + " !important;" +
        "     width: 100% !important;" +
        "     min-width: unset !important;" +
        "     max-width: unset !important;" +
        "     border-left: none !important;" +
        "   }" +

        // Add mobile back button when thread is open, hide X button
        (isThreadOpen ?
        "   #mobile-back-btn { display: block !important; }" +
        "   #close_thread_wrap { display: none !important; }" :
        "   #mobile-back-btn { display: none !important; }"
        ) +
        " }"

        // Medium screens - hide ads but keep 2-pane layout (unless no threads)
        : hideAds ?
        " @media (min-width: " + (mobileBreakpoint + 1) + "px) and (max-width: " + (adHideBreakpoint - 1) + "px) {" +
        "   .privateMessages + div { display: none !important; }" +
        (hasNoThreads ?
        // When threads list is empty, expand left panel to full width
        "   #threads_main > div:first-child { display: flex !important; width: 100% !important; min-width: unset !important; max-width: unset !important; }" +
        "   #threads-right__container { display: none !important; }" +
        "   #separator { display: none !important; }"
        :
        "   #threads_main > div:first-child { display: flex !important; min-width: 280px; }" +
        "   #threads-right__container { display: flex !important; min-width: 0 !important; flex: 1; }"
        ) +
        "   #mobile-back-btn { display: none !important; }" +
        "   .privateMessages { width: 100%; }" +
        " }"

        // Wide screens - full 3-pane layout (unless no threads)
        : " @media (min-width: " + adHideBreakpoint + "px) {" +
        (hasNoThreads ?
        // When threads list is empty, expand left panel to full width
        "   #threads_main > div:first-child { display: flex !important; width: 100% !important; min-width: unset !important; max-width: unset !important; }" +
        "   #threads-right__container { display: none !important; }" +
        "   #separator { display: none !important; }" +
        "   .privateMessages + div { display: block !important; }"
        :
        "   #threads_main > div:first-child { display: flex !important; min-width: 280px; }" +
        "   #threads-right__container { display: flex !important; min-width: 0 !important; }" +
        "   .privateMessages + div { display: block !important; }"
        ) +
        "   #mobile-back-btn { display: none !important; }" +
        " }"
      ) +
      "</style>");

    var existing = document.getElementById('js_style');
    if (existing) {
      // Update content in place to avoid removing/re-adding which causes reflow
      existing.textContent = style[0].textContent;
    } else {
      style.attr("id", "js_style").appendTo("head");
    }

    // Direct DOM manipulation for empty threads state (more reliable than CSS)
    if (hasNoThreads && !isThreadOpen) {
      $("#threads_left_container").css({
        "width": "100%",
        "max-width": "none",
        "min-width": "0",
        "flex-basis": "auto",
        "flex-grow": "1"
      });
      $("#threads-right__container").hide();
      $("#separator").hide();
    } else if (!hasNoThreads) {
      // Reset to default styles when threads exist
      $("#threads_left_container").css({
        "width": "",
        "max-width": "",
        "min-width": "",
        "flex-basis": "",
        "flex-grow": ""
      });
      // Re-apply user's saved pane width after clearing inline styles
      try {
        var savedPaneWidth = localStorage.getItem('messages-left-pane-width');
        if (savedPaneWidth) {
          $("#threads_left_container").css("flex-basis", parseInt(savedPaneWidth, 10) + "px");
        }
      } catch (e) {
        // Ignore localStorage errors
      }
      if (!isMobile || isThreadOpen) {
        $("#threads-right__container").show();
      }
      if (!isMobile) {
        $("#separator").show();
      }
    }
  }

  // Preserve thread list scroll position across resize-triggered reflows
  var tl = document.getElementById('threads_left');
  if (tl) {
    var savedScroll = tl.scrollTop;
    requestAnimationFrame(function() {
      tl.scrollTop = savedScroll;
    });
  }

  // Scroll messages to bottom if thread is open
  // With column-reverse, scrollTop=0 is bottom
  var trEl = document.getElementById('threads_right');
  if (trEl && $("#threads_main").hasClass("threads--open") && Math.abs(trEl.scrollTop) < 80) {
    trEl.scrollTop = 0;
  }
};
